import { JSX } from 'react';
import { LocationCard } from '@ahc-digital/component-library';
import { CreateLocationCardModel } from './C24LocationCard.service';
import { C24LocationCardProps } from './C24LocationCard.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { getCheckbox } from 'src/shared/param-utils';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C24LocationCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <LocationCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
      {...CreateLocationCardModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C24LocationCardProps>(Default);
